import cx from 'classnames';

import { PlayfulFooter } from './PlayfulFooter';
import { PlayfulMinimalHeader } from './PlayfulMinimalHeader';

import s from './PlayfulLayout.module.css';

type PlayfulLayoutProps = {
  children?: React.ReactNode;
};

export const PlayfulMinimalLayout = ({ children }: PlayfulLayoutProps) => {
  return (
    <div className={cx(s.playful, s.minimal)}>
      <PlayfulMinimalHeader />
      <div className={s.container}>
        <main className={cx(s.content, s.minimalLayoutContent)}>
          {children}
        </main>
      </div>
      <PlayfulFooter />
    </div>
  );
};
